const checkCookie = (name: string): boolean => {
  const regex = new RegExp(`(^| )${name}=([^;]+)`);
  const match = regex.exec(document.cookie);
  return Boolean(match);
};

export default checkCookie;
